import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import ContentManagementContainer from '../components/content-management/ContentManagementContainer';
import Spinner from '../components/common/Spinner';
import { isAdminRole } from '../utils/roleHelpers';

const ContentManagement = ({ auth: { isAuthenticated, loading, user } }) => {
  if (loading) return <Spinner />;

  if (!isAuthenticated) {
    return <Navigate to="/auth" />;
  }

  // Only allow admins and instructors to access this page
  if (!isAdminRole(user?.role) && user?.role !== 'instructor') {
    return <Navigate to="/dashboard" />;
  }

  return <ContentManagementContainer />;
};

ContentManagement.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(ContentManagement);
